/* ==========================================================================
   OLIO NARCISO — Interaktion & Motion
   Alle Effekte werden über data-Attribute ausgelöst, damit sie in jeder
   Shopify-Section funktionieren, egal wo sie im Theme-Editor stehen.
     data-reveal · data-lines · data-mask   einmalige Reveals
     data-speed="0.15"  data-scale="0.06"   Parallax / Skalierung
     data-zoom                              Bild-Zoom über Sektionshöhe
     data-fade                              Ausblenden im Hero
     data-scrub                             satzweise Aufhellung
     data-hz                                horizontales Kapitel
     data-axis="0.6"                        Sensorik-Achse füllt sich
     data-tone="#HEX"                       Flächenfarbe beim Scrollen
   ========================================================================== */
(() => {
  const I18N = window.NARCISO_I18N || {};   // übersetzte Texte (Shopify: aus locales/*.json)
  const reduce = matchMedia('(prefers-reduced-motion: reduce)').matches;
  const small = () => innerWidth < 900;
  const $ = (s, r = document) => r.querySelector(s);
  const $$ = (s, r = document) => [...r.querySelectorAll(s)];

  /* ---------- Reveals ---------- */
  const io = new IntersectionObserver(es => es.forEach(e => {
    if (!e.isIntersecting) return;
    e.target.classList.add('is-in');
    const bar = e.target.matches('[data-axis]') && e.target.querySelector('i');
    if (bar) bar.style.width = (parseFloat(e.target.dataset.axis) * 100) + '%';
    io.unobserve(e.target);
  }), { rootMargin: '0px 0px -10% 0px' });
  $$('[data-reveal],[data-lines],[data-mask],[data-axis]').forEach(el => io.observe(el));
  $$('.hero [data-reveal], .hero [data-lines], .hero [data-mask], .page-hero [data-lines], .page-hero [data-reveal]')
    .forEach(el => requestAnimationFrame(() => el.classList.add('is-in')));

  /* ---------- Hintergrund-Videos: stumm, inline, automatisch; außerhalb des Bildes pausieren ---------- */
  const play = v => { const p = v.play(); if (p) p.catch(() => {}); };
  const vio = new IntersectionObserver(es => es.forEach(e => {
    const v = e.target;
    v._inView = e.isIntersecting;
    if (e.isIntersecting && !reduce) play(v); else v.pause();
  }), { rootMargin: '200px 0px' });
  function initVideos(root = document) {
    $$('video.media__el, .media__el video', root).forEach(v => {
      v.muted = true; v.defaultMuted = true; v.loop = true; v.playsInline = true;
      v.setAttribute('muted', ''); v.setAttribute('playsinline', ''); v.removeAttribute('controls');
      if (reduce) { v.removeAttribute('autoplay'); v.pause(); return; }   // Bewegung reduzieren: Standbild
      vio.observe(v);
      v.addEventListener('loadeddata', () => play(v), { once: true });
      // Browser hält sichtbare Hintergrundvideos manchmal zum Stromsparen an → wieder starten
      v.addEventListener('pause', () => { if (v._inView && !document.hidden) setTimeout(() => { if (v.paused && v._inView) play(v); }, 250); });
    });
  }
  initVideos();
  // iPhone im Stromsparmodus / Instagram-Browser: kein Autoplay → beim ersten Tippen, Wischen oder Scrollen alle sichtbaren Videos starten
  const kick = () => $$('video.media__el, .media__el video').forEach(v => { if (v.paused && (v._inView || v.getBoundingClientRect().top < innerHeight) && !reduce) play(v); });
  ['touchstart', 'pointerdown', 'click', 'scroll', 'keydown'].forEach(t => window.addEventListener(t, kick, { passive: true }));

  /* ---------- Lange Kundenstimmen: nach 5 Zeilen weich ausblenden, „Mehr lesen“ klappt auf ---------- */
  function clampQuotes(root = document) {
    $$('[data-clamp]', root).forEach(q => {
      if (q.parentElement.classList.contains('is-open')) return;
      q.classList.add('is-clamped');
      const long = q.scrollHeight > q.clientHeight + 4;
      q.classList.toggle('is-clamped', long);
      const b = q.parentElement.querySelector('[data-clamp-toggle]');
      if (b) b.hidden = !long;
    });
  }
  document.addEventListener('click', e => {
    const b = e.target.closest('[data-clamp-toggle]'); if (!b) return;
    const open = b.parentElement.classList.toggle('is-open');
    b.setAttribute('aria-expanded', String(open));
    const m = b.closest('[data-marquee]');
    if (m) m.classList.toggle('is-reading', !!m.querySelector('.is-open'));   // Laufband hält an, solange gelesen wird
  });
  clampQuotes();
  window.narcisoClamp = clampQuotes;   // auch für Inhalte, die erst später sichtbar werden (z. B. Größenwahl)

  /* ---------- Laufband: Inhalt so oft wiederholen, bis die Breite reicht, dann nahtlos von rechts nach links ---------- */
  function initMarquees(root = document) {
    $$('[data-marquee]', root).forEach(m => {
      if (m._init) return; m._init = true;
      const track = $('.marquee__track', m), group = $('.marquee__group', m);
      if (!track || !group || !group.children.length) return;
      if (reduce) { m.classList.add('is-static'); return; }   // Bewegung reduzieren: wischbare Liste
      const base = [...group.children];
      let guard = 0;
      while (group.scrollWidth < m.clientWidth * 1.1 && guard++ < 24) {
        base.forEach(c => { const k = c.cloneNode(true); k.setAttribute('aria-hidden', 'true'); $$('a, button', k).forEach(a => a.tabIndex = -1); group.appendChild(k); });
      }
      const copy = group.cloneNode(true);
      copy.setAttribute('aria-hidden', 'true'); $$('a, button', copy).forEach(a => a.tabIndex = -1);
      track.appendChild(copy);
      const speed = parseFloat(m.dataset.marqueeSpeed) || 35;            // Pixel pro Sekunde
      m.style.setProperty('--marquee-dur', (group.scrollWidth / speed).toFixed(1) + 's');
      const t = m.parentElement.querySelector(`[data-marquee-toggle="${m.id}"]`);
      if (t) t.addEventListener('click', () => {
        const p = m.classList.toggle('is-paused');
        t.setAttribute('aria-pressed', String(p)); t.textContent = p ? (I18N.resume || 'Weiter') : (I18N.pause || 'Pause');
      });
    });
  }
  initMarquees();

  /* ---------- L'Olio: Größen-Umschalter (Tabs, Pfeiltasten) ---------- */
  function initOlioSel(root = document) {
    $$('[data-olio-sel]', root).forEach(sel => {
      if (sel._init) return; sel._init = true;
      const tabs = $$('[data-olio-tab]', sel), imgs = $$('[data-olio-img]', sel), panels = $$('[data-olio-panel]', sel);
      const pick = i => {
        tabs.forEach((t, k) => { t.setAttribute('aria-selected', String(k === i)); t.tabIndex = k === i ? 0 : -1; });
        imgs.forEach((m, k) => m.classList.toggle('is-active', k === i));
        panels.forEach((p, k) => { p.hidden = k !== i; p.classList.toggle('is-active', k === i); });
      };
      tabs.forEach((t, k) => {
        t.addEventListener('click', () => pick(k));
        t.addEventListener('keydown', e => {
          if (e.key !== 'ArrowRight' && e.key !== 'ArrowLeft') return;
          e.preventDefault();
          const n = (k + (e.key === 'ArrowRight' ? 1 : -1) + tabs.length) % tabs.length;
          pick(n); tabs[n].focus();
        });
      });
    });
  }
  initOlioSel();
  // Produktseite: kleines Bild anklicken → rückt nach oben ins große Format
  $$('.pdp__gallery').forEach(g => {
    const prep = () => [...g.children].forEach((el, i) => {
      if (i === 0) { el.removeAttribute('tabindex'); el.removeAttribute('role'); el.removeAttribute('aria-label'); return; }
      el.tabIndex = 0; el.setAttribute('role', 'button'); el.setAttribute('aria-label', I18N.zoom || 'Bild groß anzeigen');
    });
    const promote = el => {
      if (small() || el === g.firstElementChild) return;
      g.prepend(el); prep();
      const top = g.getBoundingClientRect().top + scrollY - (parseFloat(getComputedStyle(document.documentElement).getPropertyValue('--nav-h')) || 84) - 16;
      if (scrollY > top) scrollTo({ top, behavior: reduce ? 'auto' : 'smooth' });
    };
    g.addEventListener('click', e => { const el = e.target.closest('.pdp__gallery > *'); if (el) promote(el); });
    g.addEventListener('keydown', e => { if ((e.key === 'Enter' || e.key === ' ') && e.target.parentElement === g) { e.preventDefault(); promote(e.target); } });
    if (!small()) prep();
  });
  // L'Olio am Handy: Reihe startet bei der empfohlenen Flasche
  $$('.lineup').forEach(row => {
    const m = $('.lineup__item.is-main', row);
    if (m && small() && row.scrollWidth > row.clientWidth) row.scrollLeft = m.offsetLeft - (row.clientWidth - m.clientWidth) / 2;
  });
  // Nach dem Laden der Schriften stimmen die Breiten → Tempo neu berechnen
  if (document.fonts) document.fonts.ready.then(() => clampQuotes());
  if (document.fonts) document.fonts.ready.then(() => $$('[data-marquee]').forEach(m => {
    const g = $('.marquee__group', m); if (g && !m.classList.contains('is-static')) m.style.setProperty('--marquee-dur', (g.scrollWidth / (parseFloat(m.dataset.marqueeSpeed) || 35)).toFixed(1) + 's');
  }));
  document.addEventListener('visibilitychange', () => {
    if (!document.hidden && !reduce) $$('video.media__el, .media__el video').forEach(v => { if (v._inView) play(v); });
  });

  /* Shopify-Theme-Editor: neu gerenderte Sektionen sofort sichtbar machen */
  document.addEventListener('shopify:section:load', e => {
    $$('[data-reveal],[data-lines],[data-mask],[data-axis]', e.target).forEach(el => el.classList.add('is-in'));
    initVideos(e.target);
    clampQuotes(e.target);
    initMarquees(e.target);
    initOlioSel(e.target);
  });

  /* ---------- Flächenfarbe & Navigationsfarbe ---------- */
  const main = $('main');
  const nav = $('#nav');
  const toned = $$('[data-tone]');
  const toneIO = new IntersectionObserver(es => es.forEach(e => {
    if (e.isIntersecting && main) main.style.setProperty('--tone', e.target.dataset.tone);
  }), { rootMargin: '-50% 0px -50% 0px' });
  toned.forEach(el => toneIO.observe(el));
  const navIO = new IntersectionObserver(es => es.forEach(e => {
    if (e.isIntersecting) nav.classList.toggle('is-light', e.target.classList.contains('on-light'));
  }), { rootMargin: '0px 0px -90% 0px' });
  $$('main > section, main > div > section, .footer').forEach(el => navIO.observe(el));

  /* ---------- Scroll-Sequenz im Hero (Stufe 2) ----------
     Markup: <div class="seq" data-seq='["url1",…]' data-seq-m='[…]'><img class="seq__poster"><canvas class="seq__canvas"></canvas></div>
     Demo ohne Shopify: index.html?seq-demo                                                              */
  let seqUpdate = null;
  (() => {
    let el = $('.seq');
    if (!el && /[?&]seq-demo/.test(location.search)) {
      const urls = Array.from({ length: 48 }, (_, i) => `assets/demo-seq/narciso-licht-${String(i + 1).padStart(3, '0')}.jpg`);
      const media = $('.hero-a__media');
      if (media) media.innerHTML = `<div class="seq" data-seq='${JSON.stringify(urls)}'><img class="seq__poster" src="${urls[0]}" alt="Flasche Olio Narciso"><canvas class="seq__canvas" aria-hidden="true"></canvas></div>`;
      el = $('.seq');
    }
    if (!el) return;
    const hero = el.closest('.hero');
    const urls = JSON.parse((small() && el.dataset.seqM) || el.dataset.seq || '[]');
    if (reduce || urls.length < 2) return;            // Reduced Motion: nur das Standbild
    hero.classList.add('hero--seq');
    const stage = el.closest('[data-speed]');
    if (stage) { stage.removeAttribute('data-speed'); stage.removeAttribute('data-scale'); }
    const canvas = $('.seq__canvas', el), ctx = canvas.getContext('2d');
    const imgs = new Array(urls.length);
    let cur = -1;
    const load = i => new Promise(res => { const im = new Image(); im.decoding = 'async'; im.onload = () => { imgs[i] = im; res(); }; im.onerror = res; im.src = urls[i]; });
    function draw(i) {
      let k = i, d = 0;                                 // nächstes bereits geladenes Bild
      while (!imgs[k] && d < urls.length) { d++; k = imgs[i - d] ? i - d : i + d; }
      const im = imgs[k]; if (!im) return;
      const dpr = Math.min(devicePixelRatio || 1, 2), w = canvas.clientWidth * dpr, h = canvas.clientHeight * dpr;
      if (canvas.width !== w || canvas.height !== h) { canvas.width = w; canvas.height = h; }
      const sc = Math.max(w / im.naturalWidth, h / im.naturalHeight);   // wie object-fit: cover
      const dw = im.naturalWidth * sc, dh = im.naturalHeight * sc;
      ctx.drawImage(im, (w - dw) / 2, (h - dh) / 2, dw, dh);
    }
    seqUpdate = () => {
      const r = hero.getBoundingClientRect();
      const t = Math.min(1, Math.max(0, -r.top / (r.height - innerHeight)));
      const i = Math.round(t * (urls.length - 1));
      if (i !== cur) { cur = i; draw(i); }
    };
    load(0).then(async () => {
      el.classList.add('is-ready'); cur = -1; seqUpdate();
      let next = 1;                                     // Rest mit 4 parallelen Downloads nachladen
      const worker = async () => { while (next < urls.length) { await load(next++); if (Math.abs(next - cur) < 3) { cur = -1; seqUpdate(); } } };
      await Promise.all([worker(), worker(), worker(), worker()]);
      cur = -1; seqUpdate();
    });
    addEventListener('resize', () => { cur = -1; seqUpdate(); });
  })();

  /* ---------- Scroll-Loop ---------- */
  const par = $$('[data-speed]');
  const zoom = $$('[data-zoom]');
  const fades = $$('[data-fade]');
  const scrubs = $$('[data-scrub]');
  const hz = $('[data-hz]');
  const track = hz && $('.hz__track', hz);
  const prog = hz && $('.hz__progress span', hz);
  const buybar = $('.buybar');
  const buyAnchor = $('[data-buybar-after]');
  let lastY = scrollY;

  function frame() {
    const y = scrollY, vh = innerHeight;
    nav.classList.toggle('is-solid', y > 80);
    nav.classList.toggle('is-hidden', y > lastY + 2 && y > vh * .7 && !document.body.classList.contains('is-locked'));
    if (y < lastY - 2) nav.classList.remove('is-hidden');
    lastY = y;

    if (buybar && buyAnchor) buybar.classList.toggle('is-in', buyAnchor.getBoundingClientRect().bottom < 0);

    if (seqUpdate) seqUpdate();
    if (reduce) return;
    const f = small() ? .5 : 1;

    for (const el of par) {
      const host = el.closest('section') || el.parentElement;
      const r = host.getBoundingClientRect();
      if (r.bottom < -vh * .5 || r.top > vh * 1.5) continue;
      const inHero = host.matches('.hero, .page-hero');
      const p = inHero ? y : vh / 2 - (r.top + r.height / 2);
      const t = p * parseFloat(el.dataset.speed) * f;
      const sc = el.dataset.scale ? 1 + Math.min(1, y / vh) * parseFloat(el.dataset.scale) : 1;
      el.style.transform = `translate3d(0,${t.toFixed(1)}px,0)${sc !== 1 ? ` scale(${sc.toFixed(3)})` : ''}`;
    }
    for (const el of zoom) {
      const r = el.parentElement.getBoundingClientRect();
      if (r.bottom < 0 || r.top > vh) continue;
      const t = Math.min(1, Math.max(0, (vh - r.top) / (vh + r.height)));
      el.style.scale = (1.08 - t * .08).toFixed(4);
    }
    for (const el of fades) el.style.opacity = Math.max(0, 1 - y / (vh * .5)).toFixed(3);
    for (const sc of scrubs) {
      const r = sc.getBoundingClientRect();
      const s = $$('.s', sc);
      const t = (vh * .75 - r.top) / (r.height + vh * .15);
      s.forEach((el, i) => el.classList.toggle('is-on', t > i / s.length));
    }
    if (hz && !small()) {
      const r = hz.getBoundingClientRect();
      const t = Math.min(1, Math.max(0, -r.top / (r.height - vh)));
      const max = Math.max(0, track.scrollWidth - innerWidth);
      track.style.transform = `translate3d(${(-t * max).toFixed(1)}px,0,0)`;
      prog.style.transform = `scaleX(${t.toFixed(4)})`;
    }
  }
  let ticking = false;
  addEventListener('scroll', () => { if (!ticking) { ticking = true; requestAnimationFrame(() => { frame(); ticking = false; }); } }, { passive: true });
  addEventListener('resize', frame);
  frame();
  if (reduce) $$('.statement .s').forEach(s => s.classList.add('is-on'));

  /* Horizontales Kapitel: Pfeiltasten */
  if (track) track.addEventListener('keydown', e => {
    if (!['ArrowRight', 'ArrowLeft'].includes(e.key) || small()) return;
    e.preventDefault();
    const n = $$('.hz__card', track).length;
    scrollBy({ top: (e.key === 'ArrowRight' ? 1 : -1) * (hz.offsetHeight - innerHeight) / n, behavior: reduce ? 'auto' : 'smooth' });
  });

  /* ---------- Mobiles Menü ---------- */
  const menu = $('#menu'), burger = $('[data-menu]');
  if (burger) burger.addEventListener('click', () => {
    const open = !menu.classList.contains('is-open');
    menu.classList.toggle('is-open', open);
    menu.setAttribute('aria-hidden', String(!open));
    burger.setAttribute('aria-expanded', String(open));
    burger.setAttribute('aria-label', open ? (I18N.menu_close || 'Menü schließen') : (I18N.menu_open || 'Menü öffnen'));
    document.body.classList.toggle('is-locked', open);
    nav.classList.toggle('is-menu', open);
    burger.children[0].style.transform = open ? 'translateY(4px) rotate(45deg)' : '';
    burger.children[1].style.transform = open ? 'translateY(-4px) rotate(-45deg)' : '';
  });

  /* ---------- Warenkorb über die Shopify Ajax Cart API ---------- */
  const T = window.NARCISO_THEME || {};
  const fmt = cents => new Intl.NumberFormat(T.locale || 'de-DE', { style: 'currency', currency: T.currency || 'EUR' }).format(cents / 100);
  const drawer = $('#drawer'), scrim = $('.scrim'), body = $('[data-cart-body]'), count = $('.cart-count');
  const esc = s => String(s == null ? '' : s).replace(/[&<>"]/g, c => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]));
  let lastFocus = null;

  /* Versandleiste oben im Warenkorb */
  function ship(total) {
    const el = $('[data-ship]'); if (!el) return;
    const th = +el.dataset.threshold || 0;
    if (!th) { el.hidden = true; return; }
    const txt = $('[data-ship-text]', el), bar = $('[data-ship-bar]', el);
    const money = c => fmt(c);
    const free = total >= th;
    el.classList.toggle('is-free', free);
    bar.style.width = Math.min(100, total / th * 100) + '%';
    txt.textContent = !total ? el.dataset.label : free ? (I18N.ship_free || 'Innerhalb Deutschlands versandkostenfrei. Grazie.') : (I18N.ship_left || 'Noch {amount} bis zum kostenfreien Versand innerhalb Deutschlands').replace('{amount}', money(th - total));
  }

  async function refresh() {
    let c;
    try { c = await (await fetch(T.routes.cart + '.js', { headers: { Accept: 'application/json' } })).json(); } catch { return; }
    count.textContent = c.item_count;
    ship(c.total_price);
    if (!c.items.length) { body.innerHTML = `<p class="drawer__empty">${esc(T.strings.empty)}</p>`; return; }
    body.innerHTML = c.items.map(it => `<div class="line-item">
        ${it.image ? `<img src="${esc(it.image + (it.image.includes('?') ? '&' : '?') + 'width=160')}" alt="" width="72" height="90" style="width:72px;height:90px;object-fit:contain">` : '<svg class="bottle" viewBox="0 0 200 400" aria-hidden="true"><use href="#bottle"/></svg>'}
        <div><p class="h3" style="font-size:22px;margin:0">${esc(it.product_title)}</p>
          ${it.variant_title ? `<p class="caption" style="color:var(--paper-2);margin:4px 0 0">${esc(it.variant_title)}</p>` : ''}
          <div class="qty"><button type="button" data-key="${esc(it.key)}" data-q="${it.quantity - 1}" aria-label="${esc(T.strings.less)}">−</button><span>${it.quantity}</span><button type="button" data-key="${esc(it.key)}" data-q="${it.quantity + 1}" aria-label="${esc(T.strings.more)}">+</button></div></div>
        <p class="caption" style="margin:0">${fmt(it.final_line_price)}</p></div>`).join('')
      + `<div class="price-row" style="justify-content:space-between;margin-top:28px"><span class="label">${esc(T.strings.subtotal)}</span><span class="price" style="font-size:26px">${fmt(c.total_price)}</span></div>`
      + (T.strings.note ? `<p class="caption" style="color:var(--paper-2);margin-top:16px">${esc(T.strings.note)}</p>` : '');
  }
  function openCart() {
    lastFocus = document.activeElement;
    drawer.classList.add('is-open'); scrim.classList.add('is-open');
    drawer.setAttribute('aria-hidden', 'false'); document.body.classList.add('is-locked');
    setTimeout(() => $('.drawer__close').focus(), 50);
  }
  function closeCart() {
    drawer.classList.remove('is-open'); scrim.classList.remove('is-open');
    drawer.setAttribute('aria-hidden', 'true'); document.body.classList.remove('is-locked');
    if (lastFocus) lastFocus.focus();
  }
  $$('[data-cart-open]').forEach(b => b.addEventListener('click', e => { e.preventDefault(); refresh(); openCart(); }));
  $$('[data-cart-close]').forEach(b => b.addEventListener('click', closeCart));
  addEventListener('keydown', e => { if (e.key === 'Escape' && drawer.classList.contains('is-open')) closeCart(); });
  body.addEventListener('click', async e => {
    const b = e.target.closest('[data-key]'); if (!b) return;
    b.disabled = true;
    await fetch(T.routes.cart_change + '.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ id: b.dataset.key, quantity: +b.dataset.q }) });
    refresh();
  });

  /* Variantenwahl + Preis: Daten stehen als data-Attribute an den Buttons (aus Liquid) */
  $$('[data-product]').forEach(root => {
    const btns = $$('[data-variant]', root);
    let cur = btns.find(b => b.getAttribute('aria-pressed') === 'true') || btns[0];
    // Preis- und Grundpreis-Feld (nicht die Varianten-Buttons, die dieselben Daten als Attribut tragen)
    const priceEl = $('[data-price]:not([data-variant])', root), unitEl = $('[data-unit]:not([data-variant])', root), addBtns = $$('[data-add]', root);
    const show = () => {
      if (!cur) return;
      const cents = +cur.dataset.price;
      if (priceEl) priceEl.textContent = cents > 0 ? fmt(cents) : priceEl.dataset.placeholder || '';
      if (unitEl) unitEl.textContent = cur.dataset.unit || unitEl.dataset.placeholder || '';
      const ok = cur.dataset.available !== 'false' && cents > 0;
      const label = cents > 0 ? (ok ? T.strings.add : T.strings.soldout) : (I18N.soon || 'Bald erhältlich');
      addBtns.forEach(b => { b.disabled = !ok; b.textContent = label; });
      if (root.matches('[data-buybar-after]')) $$('.buybar [data-add]').forEach(b => { b.disabled = !ok; b.textContent = label; });
    };
    // Preis der Kaufleiste mit der Auswahl oben synchron halten
    if (root.matches('[data-buybar-after]')) {
      const sync = () => { const bp = $('.buybar [data-price]:not([data-variant])'); if (bp && priceEl) bp.textContent = priceEl.textContent; };
      btns.forEach(b => b.addEventListener('click', () => setTimeout(sync)));
      setTimeout(sync);
    }
    btns.forEach(b => b.addEventListener('click', () => {
      cur = b; btns.forEach(x => x.setAttribute('aria-pressed', String(x === b))); show();
      const idIn = $('[data-variant-input]', root);
      if (idIn) {
        idIn.value = cur.dataset.variant;
        idIn.dispatchEvent(new Event('change', { bubbles: true }));
        try { const u = new URL(location.href); u.searchParams.set('variant', cur.dataset.variant); history.replaceState(history.state, '', u); } catch {}
      }
    }));
    addBtns.forEach(b => b.addEventListener('click', async () => {
      const linked = !cur && root.classList.contains('buybar') && document.querySelector('[data-buybar-after] [data-variant][aria-pressed="true"]');
      const id = cur ? cur.dataset.variant : (linked ? linked.dataset.variant : root.dataset.variantId);
      if (!id) return;
      b.disabled = true;
      const item = { id: +id, quantity: 1 };
      if (root.matches('[data-buybar-after]') || root.classList.contains('buybar')) {
        const f = document.getElementById('pdp-form');
        const sp = f && (f.querySelector('[name="selling_plan"]:checked') || f.querySelector('select[name="selling_plan"]') || f.querySelector('input[type="hidden"][name="selling_plan"]'));
        if (sp && sp.value) item.selling_plan = +sp.value;
      }
      const r = await fetch(T.routes.cart_add + '.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ items: [item] }) });
      b.disabled = false;
      if (!r.ok) { const err = await r.json().catch(() => ({})); alert(err.description || T.strings.error); return; }
      await refresh();
      count.classList.remove('is-bump'); void count.offsetWidth; count.classList.add('is-bump');
      if (navigator.vibrate) navigator.vibrate(10);
      setTimeout(openCart, 120);
    }));
    show();
  });
  refresh();
  const pf = document.getElementById('pdp-form');
  if (pf) pf.addEventListener('submit', e => { e.preventDefault(); const b = pf.querySelector('[data-add]'); if (b && !b.disabled) b.click(); });

  /* Footer „Cookies“: Shopifys Cookie-Einstellungen öffnen (falls aktiv), sonst Datenschutzseite */
  $$('[data-cookie-settings]').forEach(a => a.addEventListener('click', e => {
    e.preventDefault();
    if (window.privacyBanner && typeof window.privacyBanner.showPreferences === 'function') window.privacyBanner.showPreferences();
    else location.href = '/policies/privacy-policy';
  }));

  /* Kaufbereich Startseite: Größe wählen = passenden Kaufblock zeigen */
  document.addEventListener('click', e => {
    const chip = e.target.closest('[data-size]');
    if (!chip) return;
    const sec = chip.closest('section');
    const target = sec && sec.querySelector('[data-size-panel="' + chip.dataset.size + '"]');
    if (!target || !target.hidden) return;
    // Bewertung bleibt beim Größenwechsel so, wie sie war (auf- oder zugeklappt)
    const prev = sec.querySelector('[data-size-panel]:not([hidden]) .feat-review');
    const wasOpen = !!(prev && prev.classList.contains('is-open'));
    sec.querySelectorAll('[data-size-panel]').forEach(p => { p.hidden = p !== target; });
    target.querySelectorAll('[data-reveal], [data-lines], [data-mask]').forEach(el => el.classList.add('is-in'));
    const fr = target.querySelector('.feat-review');
    if (fr) fr.classList.remove('is-open');
    if (window.narcisoClamp) window.narcisoClamp(target);   // erst kürzen (misst die Länge) …
    if (fr && wasOpen) fr.classList.add('is-open');          // … dann wie vorher aufgeklappt zeigen
    const tb = fr && fr.querySelector('[data-clamp-toggle]');
    if (tb) tb.setAttribute('aria-expanded', String(wasOpen));
    const same = target.querySelector('[data-size="' + chip.dataset.size + '"]');
    if (same) same.focus({ preventScroll: true });
  });
})();
